module.exports = __webpack_public_path__ + "img/woman_3_icon.38ea29bc.png";